import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useIsComerciales } from 'src/feature-app';

export const LegalDatosPersonalesLeads = () => {
	if (useIsComerciales()) {
		return (
			<Container
				wrap={'always'}
				padding={{ top: ContainerPadding.static250 }}
			>
				<Text appearance={TokenTextAppearance.copy200}>
					Tus datos de contacto y preferencias serán compartidos con
					el experto que hayas seleccionado, con el fin de que este
					pueda dar respuesta a tu solicitud de información.
				</Text>
			</Container>
		);
	} else {
		return (
			<Container
				wrap={'always'}
				padding={{ top: ContainerPadding.static250 }}
			>
				<Text appearance={TokenTextAppearance.copy200}>
					El responsable de los datos de contacto y preferencias que
					nos proporciones será Volkswagen Group España Distribución,
					S.A.U., que los compartirá con el concesionario que hayas
					seleccionado, con el fin de que este pueda dar respuesta a
					tu solicitud. El concesionario tratará tus datos personales
					como encargado del tratamiento.
				</Text>
			</Container>
		);
	}
};
